export default "__VITE_ASSET__ece4a254__"